
document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('header');
  var banner = document.querySelector('#banner');
  var closeIcon = document.querySelector('#close-banner');
  var body = document.body;

  closeIcon.addEventListener('click', function () {
    console.log(body)
    banner.style.display = 'none';
    body.style.paddingTop = 0;
    window.sessionStorage.setItem('info-banner', 'true');

  });
  if (window.sessionStorage.getItem('info-banner')) {
    banner.style.display = 'none';
  } else {
    banner.style.display = 'flex';
  }

  // window.addEventListener('scroll', function () {
  //   if (window.scrollY > header.clientHeight) {
  //     banner.style.position = 'fixed';
  //   } else {
  //     banner.style.position = 'static';
  //   }
  // });
});